var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex tab-container gap-2 mb-3"},[_c('router-link',{staticClass:"tab",attrs:{"to":"/training/enrolled"}},[_vm._v("Enrolled Training")]),_c('router-link',{staticClass:"tab",attrs:{"to":"/training/catalog"}},[_vm._v("All Trainings")])],1),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }